import { createSlice } from '@reduxjs/toolkit';
import CryptoJS from 'crypto-js';
// const secretPass = 'kasdaksjfdsaask';
const secretPass = process.env.REACT_APP_SECRET_KEY;

const token = localStorage.getItem('tkn');

const getToken = () => {
  if (token) {
    try {
      // Decrypt the token
      const bytes = CryptoJS.AES.decrypt(token, secretPass);

      if (bytes.sigBytes < 0) {
        localStorage.removeItem('prefix');
        localStorage.removeItem('expiresAt');
      } else {
        // Convert decrypted bytes to a string (in UTF-8)
        const tk = bytes.toString(CryptoJS.enc.Utf8);

        // Check if the token string is valid
        if (!tk || tk === '') {
          throw new Error('Decrypted token is empty or invalid');
        }

        // Attempt to parse the token as JSON
        const tkn = JSON.parse(tk);
        return tkn;
      }
    } catch (error) {
      localStorage.clear();
      console.error('Error in getToken:', error);
      // Handle error: you may want to clear token data or redirect the user
      return null;
    }
  }

  return null;
};

export const Security = createSlice({
  name: 'security',
  initialState: {
    islogin: false,
    token: getToken(),
    systemAdmin: false,
    otpMobile: '',
  },
  reducers: {
    setLogin(state, action) {
      state.islogin = action.payload;
    },

    setSystemAdminModalStatus(state, action) {
      state.systemAdmin = action.payload;
    },
    setOtpMobile(state, action) {
      state.otpMobile = action.payload;
    },
    setToken(state, action) {
      state.token = action.payload;

      const data = CryptoJS.AES.encrypt(
        JSON.stringify(action.payload),
        secretPass
      ).toString();
      localStorage.setItem('tkn', data);
    },
  },
});

export default Security.reducer;

export const { setLogin, setOtpMobile, setToken, setSystemAdminModalStatus } =
  Security.actions;

export const selectLogin = (state) => state.security.islogin;
export const selectToken = (state) => state.security.token;
export const selectSystemAdminModal = (state) => state.security.systemAdmin;
// export const selectheader = (state) => state.security.headerAuth;
export const selectOtpMobile = (state) => state.security.otpMobile;
